import { css } from 'styled-components';

export const commonResets = /*#__PURE__*/css(["font-family:'Inter',sans-serif;padding:0;margin:0;outline:none;border:none;box-sizing:border-box;"]);